import { languagesApi, translationsApi } from "@/apis/apis";
import { useEffect, useState } from "react";

import { BASE_IMPORT_DATA } from "@/Modals/LanguageManagement/BaseImport/baseImportData";
import BaseTable from "../BaseTable";
import { Get } from "@/Axios/AxiosFunctions";
import { LIST_MODE } from "@/constant/Lists/listMode";
import TranslationModal from "@/Modals/LanguageManagement/Translations/Modal";
import { columns } from "./Columns";
import { useSelector } from "react-redux";

export default function TranslationsPage() {
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const { accessToken } = useSelector((state) => state?.authReducer);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [responseData, isSuccess] = await Get({
          route: `${languagesApi}?mode=${LIST_MODE.ALL}`,
          accessToken,
        });
        if (isSuccess) {
          const sortedLanguages = responseData?.data?.data?.sort(
            (a, b) => a.id - b.id
          );
          setAvailableLanguages(sortedLanguages);
        }
      } catch (error) {
        console.error("Error fetching translation data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <BaseTable
      label="Translation"
      apiURL={translationsApi}
      columns={columns(availableLanguages)}
      ModalComponent={TranslationModal}
      importData={BASE_IMPORT_DATA.TRANSLATIONS}
      enableExport={true}
      enableExportZip={true}
      confirmationModalTitleKey="title"
      enableStatus={false}
    />
  );
}
